//sharedClaimDetails.tsx
import React from 'react'
import { Claim } from '@dataTypes/claimFeature.types'

type Column = {
  field: string
  headerText: string
  template: (rowData: Claim) => JSX.Element
  width: string
  headerStyle?: React.CSSProperties
}

export const getClaimDetailsColumns = (): Column[] => [
  {
    field: 'patientName',
    headerText: 'Patient',
    template: (rowData: Claim) => (
      <div style={{ textAlign: 'center' }}>
        <div>{rowData.patientName || '-'}</div>
      </div>
    ),
    width: '120',
    headerStyle: { textAlign: 'center' },
  },
  {
    field: 'subscriberName',
    headerText: 'Subscriber',
    template: (rowData: Claim) => (
      <div style={{ textAlign: 'center' }}>
        <div>{rowData.subscriberName || '-'}</div>
        <small className="text-muted">{rowData.subscriberId || '-'}</small>
      </div>
    ),
    width: '120',
    headerStyle: { textAlign: 'center' },
  },
  {
    field: 'insuranceCarrier',
    headerText: 'Payer',
    template: (rowData: Claim) => {
      return (
        <div style={{ textAlign: 'center' }}>
          <div>{rowData.insuranceCarrier || '-'}</div>
          <small className="text-muted">
            {rowData.insuranceCarrierPayerCode || '-'}
          </small>
        </div>
      )
    },
    width: '135',
    headerStyle: { textAlign: 'center' },
  },
  {
    field: 'providerName',
    headerText: 'Provider',
    template: (rowData: Claim) => (
      <div style={{ textAlign: 'center' }}>
        <div>{rowData.providerName || '-'}</div>
        <small className="text-muted">{rowData.providerTaxId || '-'}</small>
      </div>
    ),
    width: '140',
    headerStyle: { textAlign: 'center' },
  },
]
